import View from "../../../../../../vendor/framework/view";
import BannerService from "../../../../services/running/banner";
import Table from "../../../layout/table";

class BannerListLayout extends View
{
    service() {
        return BannerService;
    }

    componentDidMount() {
        /* global layer */
    }

    render() {
        return (
            <Table
                service={BannerService}
                searchInit={{
                    name:{name:'名称', enter:true},
                    status:{name:'状态', value:'',type: 'select', data: [{key:'',name:'--全部--'},{key:1,name:'开启'}, {key:0, name:'禁用'}], option:['key', 'name']}
                }}
                fieldsInit={{
                    id:'ID',
                    name:'名称',
                    image:{name:'图片', type:'image'},
                    typeDup:'类型',
                    sort:{name:'排序', type: 'input', change:this.server.changeSort.bind(this.server)},
                    status:{name:'状态', type:'switch', checked:1, text:'开启|禁用', change:this.server.changeState.bind(this.server)},
                    createdAt:'添加时间'
                }}
                oprationInit={{
                    edit:{name:'编辑', icon: ['edit'], click: this.edit.bind(this)},
                    delete:{name: '删除', icon:['delete', 'danger'], click:this.delete.bind(this)}
                }}
                btnInit={{
                    add:{name:'添加', click: this.add.bind(this)}
                }}
            />
        );
    }

    add(table) {
        this.layOpen({
            title:'添加',
            content:'/admin/running/banner/add',
            form:true,
            area:['900px', '90%'],
            yes: (field, index) => {
                table.server.save(field, () => {
                    layer.msg('添加成功!');
                    layer.close(index);
                    table.loadData();
                }, (msg) => {
                    layer.msg(msg);
                })
            }
        })
    }

    edit(model, table) {
        this.layOpen({
            title:'修改',
            content:'/admin/running/banner/edit/'+model.id,
            form:true,
            area:['900px', '90%'],
            yes: (field, index) => {
                field.id = model.id;
                table.server.save(field, () => {
                    layer.msg('修改成功!');
                    layer.close(index);
                    table.loadData();
                }, (msg) => {
                    layer.msg(msg);
                })
            }
        })
    }

    delete(model, table) {
        layer.confirm('您真的要删除这条数据吗?', () => {
            table.server.delete(model, () => {
                layer.msg('删除成功!');
                table.pageReload();
            }, (msg) => {
                layer.msg(msg);
            })
        })
    }
}
export default BannerListLayout;
